import React from "react";
import { Field } from "redux-form";
import customInput from "../../custom/CustomInput";
import { InputAdornment } from "@material-ui/core";
import VisibleIcon from "@material-ui/icons/Visibility";
import HiddenIcon from "@material-ui/icons/VisibilityOff";
import StrengthBar from "./StrengthBar";

const PasswordReduxField = ({ name = "password", label = "app.password", maxLength = 255, shrink, showStrength }) => {
  const [focused, setFocused] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [passwordValue, setPasswordValue] = React.useState("");

  const passwordIcon = React.useMemo(() => (
    showPassword
    ? <VisibleIcon style={{ fontSize: 20, cursor: "pointer" }} />
    : <HiddenIcon style={{ fontSize: 20, cursor: "pointer" }} />
  ), [showPassword]);

  return (
    <>
      <Field
        name={name}
        label={label}
        type={showPassword ? "text" : "password"}
        component={customInput}
        inputProps={{ maxLength }}
        InputLabelProps={{ shrink: shrink }}
        InputProps={{
          endAdornment: focused ? <InputAdornment onClick={() => setShowPassword((prev) => !prev)}>{passwordIcon}</InputAdornment> : null,
        }}
        onFocus={() => setFocused(true)}
        onChange={(e) => setPasswordValue(e.target.value)}
      />
      {showStrength && <StrengthBar password={passwordValue} focused={focused} />}
    </>
  );
};
export default PasswordReduxField;
